/**
 * Resolve Socket.IO base URL for the admin portal.
 * Prefer REACT_APP_WEBSOCKET_URL; otherwise derive from API base (strip trailing /api).
 */
export function getWebSocketBaseUrl() {
  if (process.env.REACT_APP_WEBSOCKET_URL) {
    return process.env.REACT_APP_WEBSOCKET_URL.replace(/\/$/, '');
  }

  const apiBase = process.env.REACT_APP_API_BASE_URL || '';
  if (!apiBase || apiBase.startsWith('/')) {
    return 'https://poker-crm-backend-gihm.onrender.com';
  }

  return apiBase.replace(/\/api\/?$/, '');
}
